import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Settings from './pages/Settings';
// App.tsx or your routing component
import OrderDetails from './pages/OrderDetails';
import OrderHistory from './pages/OrderHistory';
import CheckoutPage from './pages/CheckoutPage';
import DailyReport from './pages/DailyReport';
import ExportData from './pages/ExportData';
import CartPage from './pages/CartPage';
import TableSelection from './pages/TableSelection';
import TableUpdate from './components/TableUpdate';
// import { useSettings } from '../context/SettingsContext';
import OrderTypeModal from './components/OrderTypeModal';
import Header from './components/Header';
import Footer from './components/Footer';
import CheckOut from './components/CheckOut';
import ExtraOrder from './pages/ExtraOrder';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
import { SettingsProvider } from './context/SettingsContext';
import { OrderTypeProvider } from './hooks/useOrderType';
// import GoToTop from './components/GoToTop';
import { api } from './utils/api';
import TestSendToPrinter from './components/mockTest';
import PrintReceipt from './components/sendToPrinter';


const App = () => {

  // You can optionally verify token validity on load here if needed
  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);


  const vendorId = JSON.parse(localStorage.getItem('user') || '{}').vendor_id;
  // const vendorId = settings?.vendorId;
  const token = localStorage.getItem('token') || '';
  // const customerId = 0; // Include actual customer ID if available
  // const selectedTable = localStorage.getItem('selectedTable')
  // ? JSON.parse(localStorage.getItem('selectedTable')!)
  // : { id: 'You need to select a table' };  // Default table ID if not set
  // const orderType = localStorage.getItem('orderType') || 'You need to select an order type'; // Default order type if not set

  // Centralized state for controlling the OrderTypeModal
  const [orderTypeModalOpen, setOrderTypeModalOpen] = useState(false);

  const [disableOverflow, setDisableOverflow] = useState(false); // State to toggle overflow

  return (
    <AuthProvider>
      <SettingsProvider>
        <OrderTypeProvider>

          <Router>
            <div className={` overflow-x-hidden 
              ${disableOverflow ? 'overflow-y-auto' : 'overflow-y-hidden'}`}>
              <Header setOrderTypeModalOpen={setOrderTypeModalOpen} />
              <main className="pt-12 h-screen">


                {/* OrderTypeModal */}
                <OrderTypeModal isOpen={orderTypeModalOpen} onClose={() => setOrderTypeModalOpen(false)} />

                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  {/* Redirect to /login if route not found */}
                  <Route path="*" element={<Navigate to="/login" replace />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="/settings" element={<Settings />} />
                  {/* <Route path="/cart" element={<CartPage />} /> */}
                  <Route
                    path="/cart"
                    element={<CartPage setOrderTypeModalOpen={setOrderTypeModalOpen} />}
                  />
                  <Route path="/checkout" element={<CheckOut />} />
                  <Route path="/extraorder/:order_id" element={<ExtraOrder />} />

                  <Route path="/payment/:orderId" element={<CheckoutPage />} />
                  <Route path="/report" element={<DailyReport setDisableOverflow={setDisableOverflow} />} />
                  <Route path="/export" element={<ExportData setDisableOverflow={setDisableOverflow} />} />
                  <Route path="/tables" element={<TableSelection />} />
                  <Route
                    path="/tables/:tableId"
                    element={<TableUpdate vendorId={vendorId} token={token} />}
                  />
                  <Route path="/order-details/:orderId" element={<OrderDetails />} />
                  <Route path="/order-history" element={<OrderHistory setDisableOverflow={setDisableOverflow} />} />
                  <Route path="/test" element={<TestSendToPrinter />} />
                  {/* <Route path="/sendPrint" element={<PrintReceipt orderId='170' />} /> */}
                  <Route path="/mockTest" element={<TestSendToPrinter />} />

                </Routes>
              </main>

              {/* <div><GoToTop /></div> */}
              {/* Footer is accessible on every page and can control the modal */}
              <Footer setOrderTypeModalOpen={setOrderTypeModalOpen} />

            </div>
          </Router>
        </OrderTypeProvider>
      </SettingsProvider>
    </AuthProvider>
  );
};

export default App;
